<template>
  <div class="tag">
    <PageHeader :title="title">
      <Button @click="cancel">{{ getMessageByLang('cancel', 'Отмена') }}</Button>
      <Button
          :theme-color="'primary'"
          :disabled="isDisabledSave"
          @click="save"
      >
      {{ getMessageByLang('btnSave', 'Сохранить') }}
      </Button>
    </PageHeader>

    <VLoader v-if="isLoading" />
    <form v-else @submit.prevent="save" class="tag__form">
      <div class="form-group">
        <LabelRequired>
          {{ getMessageByLang("nameFull", "Название") }}
        </LabelRequired>
        <div class="form-option-required-wrap">
          <Input
            v-model="tag.name"
            :placeholder="getMessageByLang('EnterNameFull', 'Введите название')"
          />
        </div>
      </div>

      <div class="form-group">
        <label>
          {{ getMessageByLang("dscription", "Описание") }}
        </label>
        <Input
          v-model="tag.description"
          :placeholder="
            getMessageByLang('enterNameDescription', 'Введите описание')
          "
        />
      </div>
    </form>

    <AppNotification
      :text="textNotification"
      :close="handleCloseNotification"
      v-if="textNotification"
    />
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from "vue";
import { getMessageByLang } from "@/utils/translate.js";
import { useRoute, useRouter } from "vue-router";
import { isValidText } from '@/utils/form-validation.js';

import api from "@/api";

import { Button } from "@progress/kendo-vue-buttons";
import { Input } from "@progress/kendo-vue-inputs";
import VLoader from "@/ui-kit/components/VLoader";
import PageHeader from "@/components/page/PageHeader.vue";
import AppNotification from "@/components/AppNotification.vue";
import LabelRequired from "@/components/forms/LabelRequired.vue";

const isLoading = ref(true);
const tag = ref({});
const textNotification = ref(null);
const route = useRoute();
const router = useRouter();
const title = ref('Создание тега')

const isDisabledSave = computed(() => {
    if(!isValidText(tag.value.name)) {
        return true;
    }

    return false;
})

const cancel  = () => {
    router.push('/admin/tags');
}

const save = async () => {
  try {
    if(isDisabledSave.value) {
        return;
    }

    const data = {
        name: tag.value.name,
        description: tag.value.description || null
    };

    if(tag.value.id) {
      await api.tag.edit(tag.value.id, data);
    } else {
      await api.tag.create(data);
    }
    router.push('/admin/tags');

  } catch(err) {
    console.error(err);
  }
};

const getData = async (id) => {
  try {
    const {data} = await api.tag.get(id);
    
    tag.value = {
      name: data.data.name,
      description: data.data.description || '',
      id: id
    };

    title.value = `Редактирование тега ${tag.value.name}`;

  } catch (err) {
    console.error(err);

  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
    const id = route?.params?.id;

    if(id) {
        getData(id);

    } else {
        tag.value = {
            id: null,
            name: null,
            description: null
        };
        isLoading.value = false;
    }
});
</script>

<style lang="scss" scoped>
.tag {
    &__form {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
}
</style>